import { styled, useTheme } from '@mui/material';
import InputBase from '@mui/material/InputBase';

import type { ChkInputProps } from './ChkInput.types';

export const ChkInput = ({
  endAdornment,
  startAdornment,
  ...props
}: ChkInputProps) => {
  const theme = useTheme();
  return (
    <StyledInput
      {...props}
      endAdornment={theme.zoom.isElevatedZoom ? undefined : endAdornment}
      startAdornment={theme.zoom.isElevatedZoom ? undefined : startAdornment}
      inputProps={{ className: 'input-element', ...props.inputProps }}
    />
  );
};

const StyledInput = styled(InputBase)(({ theme }) => ({
  '& > .MuiInputBase-input': {
    padding: theme.spacing(0),
  },
  ...theme.typography.body1,
  fontWeight: theme.typography.fontWeightRegular,
  height: '4.8rem',
  color: theme.tokens.inputValueActive,
  border: theme.borders.borderWidth1,
  borderRadius: theme.borders.borderRadius1,
  borderColor: theme.tokens.inputBorderDefault,
  backgroundColor: theme.tokens.inputBackgroundDefault,
  padding: [theme.spacing(4), theme.spacing(3)].join(' '),
  '&:hover': {
    borderColor: theme.tokens.inputBorderHover,
  },
  '&:focus, &:focus-within': {
    borderColor: theme.tokens.inputBorderActive,
  },
  '& > .MuiInputBase-input::placeholder': {
    color: theme.tokens.inputValueDefault,
    letterSpacing: '-0.03px',
    opacity: 1,
  },
  '&.Mui-disabled, &.Mui-readOnly': {
    backgroundColor: theme.tokens.inputBackgroundDisabled,
    borderColor: theme.tokens.inputBackgroundDisabled,
    color: theme.tokens.inputValueDefault,

    '> .input-element': {
      WebkitTextFillColor: 'unset',
    },
  },

  '&.MuiInputBase-adornedStart > div:first-of-type': {
    marginRight: theme.spacing(3),
  },
  '&.MuiInputBase-adornedEnd > div:last-child': {
    marginLeft: theme.spacing(3),
  },

  '&.Mui-error': {
    borderColor: theme.tokens.inputBorderError,
    '&:focus, &:focus-within': {
      borderColor: theme.tokens.inputBorderError,
    },
  },
}));
